const isNullOrUndefined = (value) => value === null || typeof value === 'undefined';

/**
 * `null` or `undefined` is considered empty
 */
export const cleanEmptyKeys = (dirtyObject) =>
  Object.keys(dirtyObject).reduce((result, key) => {
    if (isNullOrUndefined(dirtyObject[key])) return result;

    return {
      ...result,
      [key]: dirtyObject[key],
    };
  }, {});
